module.exports = {
   name: 'underwritter_directors',
   gen_template: `
      {
         "names": "{{name.firstName}} {{name.lastName}}",
         "email": "{{internet.email}}", 
         "contact": "{{phone.phoneNumber}}",
         "image": "{{image.avatar}}"
      }
   `,
   wizard: {
      actionBtn: 'Save',
      action: 'add_director',
      pages: [
         {
            title: 'Director',
            subtitle: 'Add Director',
            forms: [
               {
                  type: 'text', form_type: 'text', label: 'First Name', model: 'first_name',
                  validation: 'required|min:2|max:50', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Last Name', model: 'last_name',
                  validation: 'required|min:2|max:50', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Title', model: 'title',
                  validation: 'required|min:2|max:8', class: 'col-12 col-md-6'
               },
               {
                  type: 'select', class: 'col-12 col-md-6', model: 'type',
                  options: [
                     { val: 'EXECUTIVE', label: 'Executive' },
                     { val: 'NON-EXECUTIVE', label: 'Non-Executive' },
                  ], validation: 'required', label: 'Type'
               },
               {
                  type: 'text', form_type: 'email', label: 'Email', model: 'email',
                  validation: 'required|min:2|max:150', class: 'col-12 col-lg-6'
               },
               {
                  type: 'mobile', class: 'col-12 col-lg-6', model: 'contact',
                  validation: 'required|digits:9', label: 'Contacts', placeholder: 'Enter the phone number'
               },
            ],
         }
      ]
   },
   table: {
      title: 'Directors',
      subtitle: 'A list of configured company directors',
      table_fields: [
         { name: 'Profile', align: 'l' },
         { name: 'Names', align: 'l' },
         { name: 'Email', align: 'l' },
         { name: 'Contact', align: 'l' },
         { name: 'actions', align: 'c' }
      ],
      searchFields: ["names", "contact", "email"],
      rowData: [
         { type: 'image', field: 'image', class: 'left' },
         { type: 'text', field: 'names', class: 'left' },
         { type: 'text', field: 'email', class: 'left' },
         { type: 'text', field: 'contact', class: 'left' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               {
                  type: 'menu', title: 'Edit', event: 'client:edit', icon: 'ico-right', params: [
                     { key: 'client', field: '*' }
                  ]
               },
               {
                  type: 'menu', title: 'View', event: 'client:view', icon: 'ico-reply', params: [
                     { key: 'email', field: 'email' },
                     { key: 'name', field: 'name' }
                  ]
               },
               // {type: 'divider'},
               {
                  type: 'menu', title: 'Delete', event: 'client:delete', icon: 'ico-mail-a', params: [
                     { key: 'email', field: 'email' }
                  ]
               },
            ]
         },
      ]
   },
}